<template>
  <div id="hrms13x-detail-tab1" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab1">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['STDEMPC1']['15'] }}
      </h3>
    </div>
    <div id="tab1" class="panel-collapse collapse in tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive">

          <div class="col-md-1 readonly-box clearfix clear-padding">
            <div class="employee-image">
              <template v-if="data.empimg !== ''">
                <img :src="baseURL + data.empimg" class="empimg">
              </template>
              <template v-else>
                <img src="~static/images/employee/no_image.png" class="empimg">
              </template>
            </div>
          </div>

          <div class="col-md-11">
            <div class="row" >
              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ labels['STDEMPC1']['20'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ data.codcomp_desc }}</div>
                </div>
              </div>
              <div class="col-md-6 clearfix clear-padding">
                <div class="unit-group-box clearfix">

                  <div class="detail-left label-left">{{ labels['STDEMPC1']['110'] }}</div>
                  <div class="readonly-group clearfix">
                    <div class="unit-group-left clearfix">
                      <div class="bg-readonly clearfix">{{ data.dteempmt_yr }}</div>
                      <div class="unit-readonly clearfix">{{ labels['STDEMPC1']['120'] }}</div>
                    </div>
                    <div class="unit-group-right clearfix">
                      <div class="bg-readonly clearfix">{{ data.dteempmt_mt }}</div>
                      <div class="unit-readonly clearfix">{{ labels['STDEMPC1']['130'] }}</div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="row" >
              <div class="col-md-6 clearfix padding-R-5">
                <div class="unit-group-box clearfix">

                  <div class="detail-left label-left">{{ labels['STDEMPC1']['30'] }}</div>
                  <div class="readonly-group clearfix">
                    <div class="input-group">
                      <div class="form-control bg-readonly">{{ data.codpos_desc }}</div>
                      <div class="input-group-addon text-title">{{ labels['STDEMPC1']['40'] }}</div>
                      <div class="input-group-addon bg-readonly">{{ data.numlvl }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 clearfix clear-padding">
                <div class="unit-group-box clearfix">

                  <div class="detail-left label-left">{{ labels['STDEMPC1']['140'] }}</div>
                  <div class="readonly-group clearfix">
                    <div class="unit-group-left clearfix">
                      <div class="bg-readonly clearfix">{{ data.dteempdb_yr }}</div>
                      <div class="unit-readonly clearfix">{{ labels['STDEMPC1']['150'] }}</div>
                    </div>
                    <div class="unit-group-right clearfix">
                      <div class="bg-readonly clearfix">{{ data.dteempdb_mt }}</div>
                      <div class="unit-readonly clearfix">{{ labels['STDEMPC1']['160'] }}</div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
            <div class="row" >
              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ labels['STDEMPC1']['50'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ data.codjob_desc }}</div>
                </div>
              </div>

              <div class="col-md-6 clearfix clear-padding">
                <div class="unit-group-box clearfix">

                  <div class="detail-left label-left">{{ labels['STDEMPC1']['170'] }}</div>
                  <div class="readonly-group clearfix">
                    <div class="unit-group-left clearfix">
                      <div class="bg-readonly clearfix">{{ data.dteeflvl_yr }}</div>
                      <div class="unit-readonly clearfix">{{ labels['STDEMPC1']['180'] }}</div>
                    </div>
                    <div class="unit-group-right clearfix">
                      <div class="bg-readonly clearfix">{{ data.dteeflvl_mt }}</div>
                      <div class="unit-readonly clearfix">{{ labels['STDEMPC1']['190'] }}</div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="row" >
              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ labels['STDEMPC1']['60'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ data.codempmt_desc }}</div>
                </div>
              </div>

              <div class="col-md-6 clearfix clear-padding">
                <div class="unit-group-box clearfix">

                  <div class="detail-left label-left">{{ labels['STDEMPC1']['200'] }}</div>
                  <div class="readonly-group clearfix">
                    <div class="unit-group-left clearfix">
                      <div class="bg-readonly clearfix">{{ data.dteefpos_yr }}</div>
                      <div class="unit-readonly clearfix">{{ labels['STDEMPC1']['210'] }}</div>
                    </div>
                    <div class="unit-group-right clearfix">
                      <div class="bg-readonly clearfix">{{ data.dteefpos_mt }}</div>
                      <div class="unit-readonly clearfix">{{ labels['STDEMPC1']['220'] }}</div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="row" >
              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ labels['STDEMPC1']['70'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ data.typemp_desc }}</div>
                </div>
              </div>

              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ labels['STDEMPC1']['230'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ data.codedlv_desc }}</div>
                </div>
              </div>
            </div>

            <div class="row" >
              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ labels['STDEMPC1']['80'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ data.typpayroll_desc }}</div>
                </div>
              </div>
              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ labels['STDEMPC1']['240'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ data.codinst_desc }}</div>
                </div>
              </div>
            </div>

            <div class="row" >
              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ data.unitcal1 === 'D' ? labels['STDEMPC1']['91'] : labels['STDEMPC1']['90'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ data.salary }}</div>
                </div>
              </div>
              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ labels['STDEMPC1']['250'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ data.codmajsb_desc }}</div>
                </div>
              </div>
            </div>

            <div class="row" >
              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ labels['STDEMPC1']['100'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ setDateOutput(data.dteempmt) }}</div>
                </div>
              </div>
              <div class="col-md-6 readonly-box clearfix clear-padding">
                <div class="detail-left label-left">{{ labels['STDEMPC1']['260'] }}</div>
                <div class="detail-right">
                    <div class="form-control bg-readonly">{{ data.codminsb_desc }}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from 'src/../env.js'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms13x-detail-tab1',
  props: [ 'labels', 'data' ],
  data () {
    return {
      baseURL: window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/'
    }
  },
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>

<style lang="scss">
#hrms13x-detail-tab1 {
  .padding-R-5 {
    padding: 0 0px 0 0;
  }

  .employee-image {
    text-align: center;
    .empimg {
      width: 128px;
      height: 128px;
    }
  }

  .bg-readonly {
    background: #ededed;
  }
  .text-title {
    font-weight: bold;
    color: #000;
  }

  .unit-group-box {
    margin: 0 0 5px 0;

    .readonly-group {
      width: 70%;
      float: left;

      @media (max-width: 991px) {
        width: 64%;
      }

      @media (max-width: 450px) {
        width: 100%;
      }

      .unit-group-left-custom {
        width: 55% !important;

        @media (max-width: 768px) {
          width: 100% !important;
        }
      }
      .unit-group-right-custom {
        width: 15% !important;

        @media (max-width: 768px) {
          width: 100% !important;
        }
      }


      .unit-group-left {
        width: 50%;
        float: left;
        padding: 0 5px 0 0;

          >.bg-readonly {
            padding: 6px 12px;
            background: #EDEDED;
            border: 1px solid #d2d6de;
            width:80%;
            float: left;

            &.readonly-width-100 {
              width: 100% !important;
              min-height: 33px;
            }
          }
          >.unit-readonly {
            padding: 6px 0px;
            text-align: center;
            background: #FFF;
            border: 1px solid #d2d6de;
            width:20%;
            float: left;
          }
      }
      .unit-group-right {
        width: 50%;
        float: left;
        padding: 0;

        >.bg-readonly {
          padding: 6px 12px;
          background: #EDEDED;
          border: 1px solid #d2d6de;
          width:80%;
          float: left;

          &.readonly-width-100 {
            width: 100% !important;
            min-height: 33px;
          }
        }
        >.unit-readonly {
          padding: 6px 0px;
          text-align: center;
          background: #FFF;
          border: 1px solid #d2d6de;
          width:20%;
          float: left;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// detailTab1.vue?64bf0194